import { render, staticRenderFns } from "./ErrorPayments.vue?vue&type=template&id=56f4e2bc&scoped=true&"
import script from "./ErrorPayments.vue?vue&type=script&lang=js&"
export * from "./ErrorPayments.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPayments.vue?vue&type=style&index=0&id=56f4e2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4e2bc",
  null
  
)

export default component.exports